import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Chip,
} from '@mui/material';

export function RecurringTaskDeleteDialog({ open, onClose, onDeleteChoice }) {
  const choices = [
    { 
      key: 'instance', 
      label: 'Delete this instance only', 
      description: 'Only delete this specific occurrence'
    },
    { 
      key: 'future', 
      label: 'Delete all future tasks', 
      description: 'Delete this and all future occurrences'
    },
    { 
      key: 'all', 
      label: 'Delete all tasks', 
      description: 'Delete all occurrences including past ones'
    }
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" component="div">
          This is a recurrent task.
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          How would you like to delete this recurring task?
        </Typography>
        <Box display="flex" flexDirection="column" gap={2}>
          {choices.map((choice) => (
            <Chip
              key={choice.key}
              label={choice.label}
              variant="outlined"
              onClick={() => onDeleteChoice(choice.key)}
              sx={{ 
                justifyContent: 'flex-start',
                p: 2,
                '&:hover': {
                  backgroundColor: 'action.hover',
                  cursor: 'pointer'
                }
              }}
            />
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
